'use client';
import { ReactComponent } from './chevron-down-xs.svg';
export const ChevronDownIconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=chevron-down-xs.js.map